import React, { useEffect, useState } from 'react';
import {
  BluetoothPrinterInfo,
  BluetoothPrinterContext,
} from '../contexs/bluetooth-printer-context';
import { useAuth } from '../contexs/auth-context';

interface BluetoothPrinterProviderProps {
  children: React.ReactNode;
}

// BluetoothPrinterProvider is a context provider component that manages the discovery
// and state of Bluetooth printers (both Epson and Star) within the application.
export const BluetoothPrinterProvider = (
  props: BluetoothPrinterProviderProps,
) => {
  const auth = useAuth();

  // State to hold the list of discovered printers
  const [printers, setPrinters] = useState<BluetoothPrinterInfo[]>([]);

  // Function to initiate the discovery of printers
  const initiateDiscovery = async () => {
    if (window.ReactNativeWebView) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'bluetooth_printers',
          payload: { action: 'initiateDiscover' },
        }),
      );
    }
  };

  const handleMessage = (event: any) => {
    const data = event.data;

    if (data?.type === 'bluetooth_printers') {
      setPrinters(data.payload.printers);
    }
  };

  useEffect(() => {
    document.addEventListener('message', handleMessage);

    return () => {
      document.removeEventListener('message', handleMessage);
    };
  });

  // useEffect hook to initiate printer discovery when the user is signed in
  useEffect(() => {
    if (auth.status === 'SIGNED_IN') {
      initiateDiscovery();
    }
  }, [auth.status]);

  return (
    // Provide the printers and initiateDiscovery function to the context
    <BluetoothPrinterContext.Provider value={{ printers, initiateDiscovery }}>
      {props.children}
    </BluetoothPrinterContext.Provider>
  );
};
